import { CUSTOMER_COMMUNITIESV2 } from 'constants/endpoints';
import { METHOD_GET } from 'requests';
import { ApiRequestConfigType } from 'requests/index.types';

export const API_GET_customerCommunitiesV2: ApiRequestConfigType = {
  method: METHOD_GET,
  url: CUSTOMER_COMMUNITIESV2,
  __typename: 'LegacyAPI',
};
